import { GameLogicBlock } from "../../types/LogicTypes"

export const getBlockById = (logicBlocks: GameLogicBlock[], id: string): GameLogicBlock | undefined => {
    let r: GameLogicBlock | undefined
    for (const l of logicBlocks) {
        if (l.id === id) {
            return l
        }
        if (l.action) {
            if (l.action.id === id) {
                return l.action
            }
            if (l.action.logic) {
                r = getBlockById(l.action.logic, id)
                if (r) return r
            }
        }
        if (l.testAction) {
            r = getBlockById(l.testAction.pass, id)
            if (r) return r
            r = getBlockById(l.testAction.fail, id)
            if (r) return r
        }
        if (l.logic) {
            r = getBlockById(l.logic, id)
            if (r) return r
        }
    }
}

export const generateBlockIdsRecursive = (logicBlocks: GameLogicBlock[]) => {
    for (const l of logicBlocks) {
        l.id = generateRandomString()
        if (l.action) {
            l.action.id = generateRandomString()
            if (l.action.logic) {
                generateBlockIdsRecursive(l.action.logic)
            }
        }
        if (l.testAction) {
            generateBlockIdsRecursive(l.testAction.pass)
            generateBlockIdsRecursive(l.testAction.fail)
        }
        if (l.logic) {
            generateBlockIdsRecursive(l.logic)
        }
    }
}

export const getLogicWithoutIds = (logicBlocks: GameLogicBlock[]): GameLogicBlock[] => {
    for (const l of logicBlocks) {
        l.id = undefined
        if (l.action) {
            l.action.id = undefined!
            if (l.action.logic) {
                getLogicWithoutIds(l.action.logic)
            }
        }
        if (l.testAction) {
            getLogicWithoutIds(l.testAction.pass)
            getLogicWithoutIds(l.testAction.fail)
        }
        if (l.logic) {
            getLogicWithoutIds(l.logic)
        }
    }
    return logicBlocks
}

export const renderCmd = (cmd: string): React.ReactNode => {
    let color: string | undefined = undefined
    if (cmd.startsWith("addHealth")) {
        color = "#C62828"
    }
    if (cmd.startsWith("addSanity")) {
        color = "#1565C0"
    }
    if (cmd.split(":")[1] === "clue") {
        color = "#2E7D32"
    }
    if (cmd.startsWith("addCondition") || cmd.startsWith("removeCondition")) {
        color = "#E65100"
    }
    if (cmd === "end") {
        color = "#757575"
    }

    cmd = cmd.replace("addCondition:", "+")
    cmd = cmd.replace("removeCondition:", "-")
    cmd = cmd.replace("addItem:", "+")
    cmd = cmd.replace("removeItem:", "-")
    cmd = cmd.replace("addHealth:", "health")
    cmd = cmd.replace("addSanity:", "sanity")

    cmd = cmd.replace("removeData:dialogue:", "data: -")
    cmd = cmd.replace("addData:dialogue:", "data: +")

    return <span style={{ color: color }}>{cmd}</span>
}

const generateRandomString = (charCount = 10): string => {
    const chars = "abcdefghijklmnopqrstuvwxyz1234567890".split("")
    let c: string[] = []
    for (let index = 0; index < charCount; index++) {
        c.push(chars[getRandomInt(chars.length -1)])
    }
    return c.join("")
}

const getRandomInt = (max: number): number => {
    return Math.floor(Math.random() * max)
}
